import {
  Button as SharedButton,
  type ButtonProps as SharedButtonProps
} from '@novelaide/ui/components/Button'
import { forwardRef } from 'react'

export type ButtonVariant = NonNullable<SharedButtonProps['variant']>
// Admin 页面按钮默认 36 高，与输入框同高；表格行、工具条里的小按钮用 sm。
export type ButtonSize = Exclude<NonNullable<SharedButtonProps['size']>, 'md'>

export interface ButtonProps extends Omit<SharedButtonProps, 'variant' | 'size'> {
  variant?: ButtonVariant
  size?: ButtonSize
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'default', size = 'default', ...props },
  ref
) {
  return <SharedButton ref={ref} variant={variant} size={size} {...props} />
})
